import React from "react";
import { Flame } from "lucide-react";

export function Logo({ size = 28 }) {
  return (
    <div className="inline-flex items-center gap-2" data-testid="brand-logo">
      <span
        className="inline-flex items-center justify-center"
        style={{
          width: size + 8,
          height: size + 8,
          background: "var(--cs-money)",
          border: "2px solid var(--cs-ink)",
          borderRadius: "0.6rem",
          boxShadow: "2px 2px 0 0 var(--cs-ink)",
        }}
      >
        <Flame size={size - 6} strokeWidth={2.5} color="#0F172A" fill="#FF6B00" />
      </span>
      <span
        className="font-display"
        style={{
          fontWeight: 900,
          fontSize: size * 0.85,
          letterSpacing: "-0.04em",
          color: "var(--cs-ink)",
        }}
      >
        CashStreak
      </span>
    </div>
  );
}
